// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"vK-z","loadingMedia":"wK-z","reviewsImagesAndVideos":"xK-z","limitHeight":"yK-z"};